import "esbuild-css-modules-plugin-ns-css:src/js/components/externalLink/externalLink.module.css";

import { inject } from "esbuild-css-modules-plugin-ns-js:src/js/components/externalLink/externalLink.module.css:injector.js";
export default new Proxy({
  "linkText": "externalLink-module__linkText_XU15yq__1100"
}, {
  get: function(source, key) {
    inject();
    return source[key];
  }
});
      